/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Orders_Cancel_Estes_PickupInputs */

const en_orders_cancel_estes_pickup = /** @type {(inputs: Orders_Cancel_Estes_PickupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cancel ESTES Pickup (${i?.count})`)
};

const es_orders_cancel_estes_pickup = /** @type {(inputs: Orders_Cancel_Estes_PickupInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Cancelar recoleccion ESTES (${i?.count})`)
};

/**
* | output |
* | --- |
* | "Cancel ESTES Pickup ({count})" |
*
* @param {Orders_Cancel_Estes_PickupInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_cancel_estes_pickup = /** @type {((inputs: Orders_Cancel_Estes_PickupInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Cancel_Estes_PickupInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_cancel_estes_pickup(inputs)
	return es_orders_cancel_estes_pickup(inputs)
});